var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 7.50423C9 7.35743 8.97348 7.22191 8.92043 7.09768C8.86149 6.97346 8.77308 6.85488 8.65521 6.74195L1.76817 0.287973C1.56778 0.0959918 1.32613 6.70871e-07 1.04322 6.95604e-07C0.848722 7.12607e-07 0.674851 0.0451734 0.52161 0.135518C0.362474 0.220216 0.235756 0.338793 0.141452 0.491249C0.0471503 0.638058 -1.24125e-06 0.801807 -1.22545e-06 0.982497C-1.20175e-06 1.25353 0.109036 1.49351 0.327111 1.70243L6.5334 7.50424L0.327112 13.306C0.109037 13.515 -1.09093e-07 13.7521 -8.58925e-08 14.0175C-6.96025e-08 14.2038 0.0471515 14.3704 0.141454 14.5172C0.235757 14.664 0.362475 14.7798 0.521611 14.8645C0.674852 14.9548 0.848723 15 1.04322 15C1.32613 15 1.56778 14.9068 1.76817 14.7205L8.65521 8.26652C8.77308 8.15359 8.86149 8.03501 8.92043 7.91078C8.97348 7.78656 9 7.65104 9 7.50423Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownIcon);
export default __webpack_public_path__ + "static/media/DropdownIcon.78c19486159dd8875d08c3afa75022f1.svg";
export { ForwardRef as ReactComponent };